import React, {
  useContext,
  forwardRef,
  useState,
  useLayoutEffect,
  useEffect,
} from "react";
import { FilterOrderByItems } from "../../../../mock/filters";
import useAxios from "../../../../api/useAxios";
import OrderContext from "../../../../context/OrderContext";
// DATE
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AuthContext from "../../../../context/AuthContext";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Filters = () => {
  let { user } = useContext(AuthContext);
  let {
    from,
    setDateFrom,
    to,
    setDateTo,
    clearDateRange,
    setOrderby,
    setShippingStatus,
    setVendor,
    setOrderStatus,
    setSearchParams,
    searchParams,
    csvexport,
    setPage,
  } = useContext(OrderContext);
  const [t, i18n] = useTranslation("common");

  const isAdmin = user.roles.includes("ROLE_all-seeing");

  function handleChangeVendor(event) {
    setVendor(event.target.value);
    if (event.target.value === "") {
      searchParams.delete("vendor");
    } else {
      searchParams.set("vendor", event.target.value);
    }
    setSearchParams(searchParams.toString());
  }

  const dateFrom = from.replace("T00:00:00.000Z", "");
  const dateTo = to.replace("T00:00:00.000Z", "");

  const DateFromCustomInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <button
        className="btn btn-secondary  datepic-btn"
        onClick={onClick}
        ref={ref}
      >
        <i className="feather icon-calendar"></i>
        {from ? <span>{dateFrom}</span> : t("app.From")}
      </button>
    </>
  ));

  const DateToCustomInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <button
        className="btn  btn-secondary datepic-btn"
        onClick={onClick}
        ref={ref}
      >
        <i className="feather icon-calendar"></i>
        {to ? <span>{dateTo}</span> : t("app.To")}
      </button>
    </>
  ));

  function handleStartDate(from) {
    const dateFrom = moment(from).format("Y-MM-DD") + "T00:00:00.000Z";
    setDateFrom(dateFrom);
    searchParams.set("from", dateFrom);
    setSearchParams(searchParams.toString());
  }
  function handleEndDate(to) {
    const dateTo = moment(to).format("Y-MM-DD") + "T00:00:00.000Z";
    setDateTo(dateTo);
    searchParams.set("to", dateTo);
    setSearchParams(searchParams.toString());
  }

  function handleClearDate() {
    clearDateRange();
  }

  function handleChangeOrderByDate(event) {
    searchParams.set("page", 1);
    const selected = event.target.value;
    if (selected === "today") {
      let d = new Date();
      let n = new Date();
      n.setDate(n.getDate() + 1);
      let param = moment(d).format("Y-MM-DD") + "T00:00:00.000Z";
      let paramend = moment(n).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "yesterday") {
      let d = new Date();
      d.setDate(d.getDate() - 1);
      let n = new Date();
      n.setDate(n.getDate());
      let param = moment(d).format("Y-MM-DD") + "T00:00:00.000Z";
      let paramend = moment(n).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "l7d") {
      const past7Days = [...Array(8).keys()].map((index) => {
        const date = new Date();
        date.setDate(date.getDate() - index);
        return date;
      });
      let param = moment(past7Days[7]).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      let n = new Date();
      n.setDate(n.getDate());
      let paramend = moment(n).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "l30d") {
      const past7Days = [...Array(31).keys()].map((index) => {
        const date = new Date();
        date.setDate(date.getDate() - index);
        return date;
      });

      let param = moment(past7Days[30]).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      let n = new Date();
      n.setDate(n.getDate());
      let paramend = moment(n).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "tm") {
      function getFirstDayOfMonth(year, month) {
        return new Date(year, month, 1);
      }
      const date = new Date();
      const firstDayCurrentMonth = getFirstDayOfMonth(
        date.getFullYear(),
        date.getMonth()
      );
      let param =
        moment(firstDayCurrentMonth).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      const today = new Date();
      let paramend =
        moment(today.toString()).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "lm") {
      function getFirstDayOfMonth(year, month) {
        return new Date(year, month, 1);
      }
      const date = new Date();
      const firstDayCurrentMonth = getFirstDayOfMonth(
        date.getFullYear(),
        date.getMonth() - 1
      );
      let param =
        moment(firstDayCurrentMonth).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);

      var month = date.getMonth() - 1; // January
      var d = new Date(date.getFullYear(), month + 1, 0);
      let paramend = moment(d.toString()).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "ty") {
      const d = new Date(new Date().getFullYear(), 0, 1);
      let param = moment(d).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);
      const today = new Date();
      let paramend =
        moment(today.toString()).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    } else if (selected === "ly") {
      const d = new Date(new Date().getFullYear() - 1, 0, 1);
      let param = moment(d).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateFrom(param);
      searchParams.set("from", param);

      const lastDay = new Date(new Date().getFullYear() - 1, 11, 31);
      let paramend = moment(lastDay).format("Y-MM-DD") + "T00:00:00.000Z";
      setDateTo(paramend);
      searchParams.set("to", paramend);
      setSearchParams(searchParams.toString());
    }
  }
  const [vendorList, setVendorList] = useState();

  let api = useAxios();

  let fetchVendorsData = async () => {
    let response = await api.get(`/manager/vendor?page=1&limit=50`);
    if (response.status === 200) {
      setVendorList(response.data.list);
      return response.data;
    }
  };

  useEffect(() => {
    fetchVendorsData();
  }, []);

  return (
    <>
      {isAdmin && (
        <div className="form-group mx-sm-1 mr-5">
          <select className="form-control" onChange={handleChangeVendor}>
            <option value={""}>{t("app.Vendors")}</option>

            {vendorList?.map((v) => (
              <option value={v.name}>{v.id}</option>
            ))}
          </select>
        </div>
      )}

      <div className="form-group mx-sm-1">
        <select className="form-control" onChange={handleChangeOrderByDate}>
          <option key="1" value={"none"}>
            Order by{" "}
          </option>
          <option key="2" value={"today"}>
            Today
          </option>
          <option key="3" value={"yesterday"}>
            Yesterday
          </option>
          <option key="4" value={"l7d"}>
            Last 7 Days
          </option>
          <option key="5" value={"l30d"}>
            Last 30 Days
          </option>
          <option key="6" value={"tm"}>
            This Month
          </option>
          <option key="7" value={"lm"}>
            Last Month
          </option>
          <option key="8" value={"ty"}>
            This Year
          </option>
          <option key="9" value={"ly"}>
            Last Year
          </option>
        </select>
      </div>
      <div className="form-group mx-sm-1"> or</div>
      <div className="form-group mx-sm-1">
        <div className="date-filter">
          <DatePicker
            onChange={(from) => handleStartDate(from)}
            customInput={<DateFromCustomInput />}
          />
          <DatePicker
            onChange={(date) => handleEndDate(date)}
            customInput={<DateToCustomInput />}
          />
        </div>
        {from || to ? (
          <button onClick={handleClearDate} className="clear-filter">
            {t("app.clear")}
            <i className="feather icon-x"></i>
          </button>
        ) : (
          ""
        )}
      </div>

      <button
        className="btn btn-secondary export-csv"
        onClick={() => csvexport()}
      >
        Export CSV
      </button>
    </>
  );
};

export default Filters;
